import { createFileRoute, Outlet } from "@tanstack/react-router";
import { useTranslation } from "react-i18next";
import { PageTitle } from "@/contexts/page-title-context";
function TripsLayout({ children }: { children: React.ReactNode }) {
  const { t: tTrips } = useTranslation("trips");

  return (
    <>
      <PageTitle>{tTrips("title")}</PageTitle>
      {children}
    </>
  );
}

export const Route = createFileRoute("/_app/trips")({
  component: function LayoutRoute() {
    return (
      <TripsLayout>
        <Outlet />
      </TripsLayout>
    );
  },
});
